import Vue from 'vue';
import { getAppInfo, getUserInfoByUserId, findUser, getArea } from '@iebdc/api/user-server.js';
import {
  checkTokenByAppKey,
  // getCode
} from '@iebdc/api/login';
import { crypto } from '@iebdc/utils/crypto';
import { localDataUser } from '../utils/local-data';
export const checkTokenHandle = (token, next) => {
  checkTokenByAppKey({
    authorization: token,
    ssoLoginUrl: crypto.decryptByDES(window.CONFIG.loginTy),
    appKey: window.CONFIG.APP_IEBDC_KEY,
  }).then((res) => {
    if (res.success) {
      const params = {
        userId: res.data.appKey,
        userName: res.data.loginName,
        access_token: token,
      };
      localDataUser.set({
        ...localDataUser.get(),
        token: res.data.gmsso_cli_ec_key,
      });
      Promise.all([getAppInfo(), getUserInfoByUserId(params), findUser(params), getArea()]).then(() => {
        Vue.prototype.$message.success('登录成功！');
        next('/');
      });
    }
  });
};
//事项办理专用
export const sxblcheckTokenHandle = (token, next, to) => {
  checkTokenByAppKey({
    authorization: token,
    ssoLoginUrl: crypto.decryptByDES(window.CONFIG.loginTy),
    appKey: window.CONFIG.APP_IEBDC_KEY,
  }).then((res) => {
    if (res.success) {
      const params = {
        userId: res.data.appKey,
        userName: res.data.loginName,
        access_token: token,
      };
      localDataUser.set({
        ...localDataUser.get(),
        token: res.data.gmsso_cli_ec_key,
      });
      Promise.all([getAppInfo(), getUserInfoByUserId(params), findUser(params), getArea()]).then(() => {
        Vue.prototype.$message.success('登录成功！');
        //   setTimeout(() => {
        //     console.log('====222', to.fullPath);
        //     // console.log(Vue.$router.push({ path: '/home/check-in1', params: { lcdm: lcdm } }));

        //       next(vm=>{
        //         console.log(vm);
        //       })
        //   }, 3000);
        next({ path: '/home/check-in1' });
        //   next('/');
        //   next({ path: '/home/check-in1', params: { lcdm: lcdm } });
      });
    }
  });
};

//房产查询专用
export const fcxxcheckTokenHandle = (token, next, to) => {
  checkTokenByAppKey({
    authorization: token,
    ssoLoginUrl: crypto.decryptByDES(window.CONFIG.loginTy),
    appKey: window.CONFIG.APP_IEBDC_KEY,
  }).then((res) => {
    if (res.success) {
      const params = {
        userId: res.data.appKey,
        userName: res.data.loginName,
        access_token: token,
      };
      localDataUser.set({
        ...localDataUser.get(),
        token: res.data.gmsso_cli_ec_key,
      });
      Promise.all([getAppInfo(), getUserInfoByUserId(params), findUser(params), getArea()]).then(() => {
        Vue.prototype.$message.success('登录成功！');
        //   setTimeout(() => {
        //     console.log('====222', to.fullPath);
        //     // console.log(Vue.$router.push({ path: '/home/check-in1', params: { lcdm: lcdm } }));

        //       next(vm=>{
        //         console.log(vm);
        //       })
        //   }, 3000);
        next({ path: '/home/info-search/newQuanSZM-query' });
        //   next('/');
        //   next({ path: '/home/check-in1', params: { lcdm: lcdm } });
      });
    }
  });
};
